export enum TaskGroupItemType {
    CollectingTask,
    ContainerPlacingTask,
    DeliveringTask,
    ReturningTask,
    RefundingTask,
}
